import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { bottom, boxShadow, color, display, position, right, zIndex } from 'styled-system';

import { Flex } from 'common/components/Flex';
import { FIXED_HOMECLUB_CTA_CONTAINER } from 'common/constants/z-index';
import { boxSizing } from 'common/theme/system-utilities';

const UnstyledFixedBottomContainer = styled(Flex)<any>`
  ${boxShadow};
  ${position};
  ${zIndex};
  ${bottom};
  ${right};
  ${display};
  ${color};
  ${boxSizing};
  ${boxSizing};
`;

const FixedBottomContainer = (props: ComponentProps<typeof UnstyledFixedBottomContainer>) => (
  <UnstyledFixedBottomContainer
    display={[null, null, 'none']}
    position="fixed"
    width="100%"
    bottom={0}
    right={0}
    px="sp_16"
    py="sp_8"
    bg="sys.neutral.background.default"
    boxSizing="border-box"
    alignItems="center"
    justifyContent="center"
    boxShadow="lowTop"
    zIndex={FIXED_HOMECLUB_CTA_CONTAINER}
    {...props}
  />
);

export default FixedBottomContainer;
